/** Page parameters */
export const EMPLOYEE_ID_PARAM = 'employeeId';
export const COMPANY_ID_PARAM = 'companyId';
export const COUNTRY_CODE_PARAM = 'countryCode';
export const STATUS_PARAM = 'status';
export const CATEGORY_PARAM = 'category';
export const DATE_FROM_PARAMETER = 'dateFrom';
export const DATE_TO_PARAMETER = 'dateTo';
